// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__aREiQ","input":"search_input__3ZNPX","text":"search_text__-mfs0"};